<template>
<div class="invoice_operation_page">
  <a :href="pdfPath" class="margin_r" target="_blank">PDF</a>
  <a :href="csvPath" target="_blank">CSV</a>
</div>
</template>

<script>
import {APP} from "../../../common/util";

export default {
  data() {
    return {
      baseDownloadUrl: APP.DOMAIN + "filedownload/"
    }
  },
  computed: {
    pdfPath() {
      const {
        pdfFileId
      } = this.params.data;
      console.log(this.params);
      return `${this.baseDownloadUrl}${pdfFileId}`
    },
    csvPath() {
      const {
        csvFileId
      } = this.params.data;
      return `${this.baseDownloadUrl}${csvFileId}`
    },
  },
}
</script>

<style lang="scss" scoped>
.invoice_operation_page {
  width: 100%;

  a {
    border-left: 3px solid #3598dc;
    padding: 2px 2px 2px 5px;
    cursor: pointer;
  }
}
</style>
